import { render, staticRenderFns } from "./ChartView.vue?vue&type=template&id=680f5c20"
import script from "./ChartView.vue?vue&type=script&lang=js"
export * from "./ChartView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports